const Loader = ({ loadingText }: { loadingText?: string }) => {
  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden flex flex-col items-center justify-center bg-white bg-opacity-75">
      <div className="flex">
        <div className="relative">
          <div className="w-16 h-16 rounded-full absolute border-[6px] border-solid border-gray-200"></div>
          <div
            className="w-16 h-16 rounded-full animate-spin absolute
            border-[6px] border-solid border-yellow-500 border-t-transparent shadow-md"></div>
        </div>
        <div className="relative mt-20 font-medium text-center">
          {loadingText || 'Loading'}
        </div>
      </div>
    </div>
  );
};

export default Loader;
